import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { getTotalIncomeData } from '../../../requests/api/dashboard';
import { DEFAULT_API_ERROR_MESSAGE } from '../../../utils/errors';
import { useYear } from '../../../hooks/useYear';
import Page from '../../../components/Layout/Page';
import IndicatorsTable from '../components/table';
import { TotalIncomeData } from '../types';
import useStyles from './styles';

const TotalIncome: React.FC = () => {
  const classes = useStyles();
  const { selectedYear } = useYear();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [
    totalIncomeData, setTotalIncomeData,
  ] = useState<TotalIncomeData>([{
    id: 'totals',
    label: '',
    values: {
      tuition: { amount: 0, variation: 0 },
      fee: { amount: 0, variation: 0 },
      intensiveI: { amount: 0, variation: 0 },
      intensiveII: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lad',
    label: 'LAD',
    values: {
      tuition: { amount: 0, variation: 0 },
      fee: { amount: 0, variation: 0 },
      intensiveI: { amount: 0, variation: 0 },
      intensiveII: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      percentageTotal: 0,
    },
  },
  {
    id: 'lod',
    label: 'LOD',
    values: {
      tuition: { amount: 0, variation: 0 },
      fee: { amount: 0, variation: 0 },
      intensiveI: { amount: 0, variation: 0 },
      intensiveII: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      percentageTotal: 0,
    },
  },
  {
    id: 'em',
    label: 'EM',
    values: {
      tuition: { amount: 0, variation: 0 },
      fee: { amount: 0, variation: 0 },
      intensiveI: { amount: 0, variation: 0 },
      intensiveII: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      percentageTotal: 0,
    },
  },
  {
    id: 'eme',
    label: 'EME',
    values: {
      tuition: { amount: 0, variation: 0 },
      fee: { amount: 0, variation: 0 },
      intensiveI: { amount: 0, variation: 0 },
      intensiveII: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      percentageTotal: 0,
    },
  }]);

  useEffect(() => {
    const fetchTotalIncomeData = async () => {
      try {
        const response = await getTotalIncomeData(selectedYear);
        setTotalIncomeData(response.totalIncomeData);
      } catch (err) {
        const e = err as AxiosError;
        enqueueSnackbar(e.response?.data.message || DEFAULT_API_ERROR_MESSAGE, {
          variant: 'error',
        });
      }
    };

    fetchTotalIncomeData();
  }, [selectedYear]);

  const handleGoBack = () => {
    history.push('/dashboard/financiero');
  };

  return (
    <Page title="Ingresos totales">
      <Box>
        <Box className={classes.backButtonContainer}>
          <IconButton
            onClick={handleGoBack}
            className={classes.backButton}
            size="small"
          >
            <ArrowBackIos className={classes.backIcon} />
          </IconButton>
          <Typography className={classes.pageTitle}>
            Ingresos totales
          </Typography>
        </Box>

        <Box className={classes.enrollmentsContainer}>
          <IndicatorsTable
            columns={[{
              id: 'tuition',
              label: 'Matrículas',
            }, {
              id: 'fee',
              label: 'Arancel anual',
            }, {
              id: 'intensiveI',
              label: 'Intensivos I',
            }, {
              id: 'intensiveII',
              label: 'Intensivos II',
            }, {
              id: 'total',
              label: `Total ingresos ${selectedYear}`,
            }, {
              id: 'percentageTotal',
              label: '',
            }]}
            rows={totalIncomeData}
          />
        </Box>
      </Box>
    </Page>
  );
};

export default TotalIncome;
